// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wallet-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <g strokeLinecap='round'>
      <path d='m13.781 5.104-1.65-3.3a1.062 1.062 0 0 0-1.425-.475l-7.55 3.775m12.75 8.5a1.063 1.063 0 0 0 1.063-1.062V9.354a1.063 1.063 0 0 0-1.063-1.062H13.25a2.657 2.657 0 0 0 0 5.312z' />
      <path
        fill='currentColor'
        d='M13.781 4.604a2.626 2.626 0 0 1 2.625 2.625V8.3c-.768 0-1.906-.05-3.156-.05-1.75 0-2.65.929-2.65 2.698 0 1.542 1.204 2.652 2.65 2.652h2.656c.172 0 .34-.046.5-.1.094 0 0 1.167 0 1.167a2.626 2.626 0 0 1-2.625 2.625H3.156a2.626 2.626 0 0 1-2.625-2.625V7.229a2.626 2.626 0 0 1 2.625-2.625z'
      />
    </g>
    <path d='M13.25 11.213a.266.266 0 1 1 0-.53m0 .53a.266.266 0 1 0 0-.53' />
  </g>
);

export const viewBox = '0 0 18 18';
